import { render, staticRenderFns } from "./DemoDatatableFixedHeader.vue?vue&type=template&id=92670530&"
import script from "./DemoDatatableFixedHeader.vue?vue&type=script&lang=js&"
export * from "./DemoDatatableFixedHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VChip,VDataTable,VImg})
